<div>
  <form [formGroup]="addFundForm" (ngSubmit)="onSubmit()" [ngClass]="{'displayForm': isFormShow, 'hiddenForm': !isFormShow}" class="saved-card-form">
    <div class="cardDetailForm ">
      <div class="saveCardFrom">
        <flash-messages></flash-messages>
        <div class="formControlMain">
           <div class="disIb ">
             <label class="cardDetailLabel">Deposit Amount </label>
             <div class="deposit-amount-input-bar">
               <mat-form-field class="form-control form-input-amount">
                <span matPrefix>$</span>
                 <input matInput type="custom" formControlName="custom_amt" (blur)="getAmount('other')"  (keypress)="keyPress($event)">
               </mat-form-field>
             </div>
             <div class="deposit-amount-buttons">
               <ng-container *ngIf="fundsData.dataList">
                 <button type="button" mat-stroked-button 
                    [ngClass]="{'customChargeBtn': true, 'checked_amt':((item.money == f.selected_package.value))}" 
                    class="customChargeBtn" *ngFor="let item of fundsData.dataList" (click)="getAmount(item)" [disabled]="isCheckingPromo">
                      ${{item.money | number }}
                </button>
               </ng-container>
             </div>
             <mat-error *ngIf="submitted && (this.f.selected_package.errors && this.f.selected_package.errors.required)  || (this.f.custom_amt.errors && this.f.custom_amt.errors.required)">
               Deposit amount is required.
             </mat-error>
             <mat-error *ngIf="submitted && this.f.custom_amt.errors && this.f.custom_amt.errors.pattern">
               Deposit amount is invalid.
             </mat-error>
             <mat-error class="pt-0" *ngIf="submitted && this.f.custom_amt && this.f.custom_amt.errors && this.f.custom_amt.errors.minDepositError">
               Deposit must be greater than ${{minDeposit}}.
           </mat-error>
             <mat-error class="pt-0" *ngIf="submitted && this.f.custom_amt && this.f.custom_amt.errors && this.f.custom_amt.errors.maxDepositError">
               Deposit must not exceed ${{maxDeposit}}.
           </mat-error>
           </div>
         </div>
         <div class="formControlMain" *ngIf="!fundsData.hidePromo">
           <div class="disIb">
             <div class="promo-code-checker">
               <div class="promo-code-checker-input">
                 <mat-form-field class="form-control promocode-ck" >
                   <input matInput type="text" formControlName="promo_code" (input)="promoCodeDisable()" maxlength="20">
                 </mat-form-field>
                 <span class="checkValue" *ngIf="promo_code_validation.icon" [ngStyle]="{'color': promo_code_validation.icon_color}" ><i  [class]="promo_code_validation.icon"></i></span>
               </div>
               <button type="button" mat-raised-button color="" class="custom-btn check-pormoBtn" (click)="checkPromoCode('card')" [disabled]="isCheckingPromo || isCheckPromoDis">
                 <span *ngIf="!isCheckingPromo">Apply</span>
                 <span *ngIf="isCheckingPromo" class="circular-loader"></span>
                </button>
             </div>
           </div>
           <mat-error *ngIf="promo_code_validation && promo_code_validation.message && promo_code_validation.validate!='yes'" style="position: relative;">{{
             promo_code_validation.message }}</mat-error>
             <div class="promoCodeBonus" *ngIf="promo_code_validation && promo_code_validation.message && promo_code_validation.validate=='yes'">
                  +${{promo_code_validation.bonus_amount }} Bonus!
              </div>
         </div>
         <div class="formControlMain card-details-save-card">
           <div class="disIb w-70">
             <mat-form-field class="form-control" id="savedCardsOptionsLabel" >
               <mat-select formControlName="saved_Card_id" >
                   <mat-option *ngFor="let Paymentvalue of fundsData.paymentMethod" [value]="Paymentvalue.id" >{{(Paymentvalue.cardDetail.cardBin | slice:0:4)+' XXXX XXXX '+Paymentvalue.cardDetail.lastDigits}}</mat-option> 
               </mat-select>
             </mat-form-field>
           </div>
           <div class="disIb w-25">
             <mat-form-field class="form-control lh-50">
               <input matInput type="password" formControlName="cvv" placeholder="CVV"  maxlength="4">
             </mat-form-field>
             <mat-error *ngIf="submitted && f.cvv.errors && f.cvv.errors.required">
                 CVV is required.
             </mat-error>
             <mat-error *ngIf="submitted && this.f.cvv.errors && (this.f.cvv.errors.maxlength || this.f.cvv.errors.minlength)">
                 CVV must be min 3 digit and max 4 digit.
             </mat-error>
           </div>
         </div>
         <div class="text-left width100 ">
           <button mat-raised-button color="primary" class="popupFundBtn" [disabled]="isDisable" >Deposit</button>
           <div class="saved-cards">
             <div class="deposit-saved-cards" id="master">
              <img [src]="awsUploadUrl+'mastercard_logo.png'" alt="">
             </div>
             <div class="deposit-saved-cards" id="visa">
              <img [src]="awsUploadUrl+'visa_logo.png'" alt="">
             </div>
             <div class="deposit-saved-cards" id="express">
              <img [src]="awsUploadUrl+'express_logo.png'" alt="">
             </div>
            </div>
         </div>
      </div>
    </div>
  </form>
</div>